// 组件对象，大写
import cloudPrint from './cloudPrint.vue'
export default cloudPrint
